import http from "../utils/http";

/**
 *  规章制度分页列表
 */
export function regulationList(params) {
  return http({
    method: 'get',
    url: '/business/bizRegulation/paging',
    params
  });
}

/**
 *  规章制度详情
 */
export function regulationDetail(params) {
  return http({
    method: 'get',
    url: '/business/bizRegulation/find',
    params
  });
}

/**
 *  添加规章制度
 */
export function regulationAdd(data) {
  return http({
    method: 'post',
    url: '/business/bizRegulation/add',
    data
  });
}

/**
 *  编辑规章制度
 */
export function regulationEdit(data) {
  return http({
    method: 'post',
    url: '/business/bizRegulation/update',
    data
  });
}

/**
 *  删除规章制度
 */
export function regulationDel(data) {
  return http({
    method: 'post',
    url: '/business/bizRegulation/delete',
    params: data
  });
}

/**
 *  富文本图片文件上传,返回url
 */
export function upload(data) {
  return http({
    method: 'post',
    url: '/common/file/upload/url',
    data
  });
}



